import { render, staticRenderFns } from "./GlobalMenu.vue?vue&type=template&id=9ffafab6&"
import script from "./GlobalMenu.vue?vue&type=script&lang=js&"
export * from "./GlobalMenu.vue?vue&type=script&lang=js&"
import style0 from "./GlobalMenu.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports